import { getSimpleValue } from './value-getter';
import type { IdType } from '@servicetitan/data-query';

interface OperatorOpts<TO> {
    valueSelector?: (item: TO) => IdType;
    rowValueSelector?: (item: any) => IdType | undefined;
}

export const selectColumnMenuFilterOperators = {
    getContains: <TO>(opts?: OperatorOpts<TO>) => {
        const { valueSelector = getSimpleValue, rowValueSelector = getSimpleValue } = opts ?? {};

        return (value: any, options?: TO[]) =>
            options?.some(opt => valueSelector(opt) === rowValueSelector(value));
    },
    getEquals: <TO>(opts?: OperatorOpts<TO>) => {
        const { valueSelector = getSimpleValue, rowValueSelector = getSimpleValue } = opts ?? {};

        return (value: any, option?: TO) =>
            option === undefined ? false : valueSelector(option) === rowValueSelector(value);
    },
};
